module.exports = __webpack_public_path__ + "static/media/pesbon.dcccd551.jpeg";